export enum Platform {
	Windows = 'win32',
	Mac = 'darwin'
}
